import React from 'react';
import { FaShieldAlt, FaRocket, FaBalanceScale } from 'react-icons/fa';

const MarketRegimeCard = ({ regime, notes }) => {
  const normalizedRegime = regime?.toLowerCase() || '';

  const getRegimeConfig = () => {
    if (normalizedRegime.includes('risk-off') || normalizedRegime.includes('risk off') || normalizedRegime.includes('defensive')) {
      return {
        icon: FaShieldAlt,
        label: 'Risk-Off',
        color: '#f59e0b',
        bgColor: 'rgba(245, 158, 11, 0.15)',
        borderColor: 'rgba(245, 158, 11, 0.3)',
        description: 'Defensive market conditions'
      };
    }
    if (normalizedRegime.includes('risk-on') || normalizedRegime.includes('risk on') || normalizedRegime.includes('aggressive')) {
      return {
        icon: FaRocket,
        label: 'Risk-On',
        color: '#10b981',
        bgColor: 'rgba(16, 185, 129, 0.15)',
        borderColor: 'rgba(16, 185, 129, 0.3)',
        description: 'Favorable for risk assets'
      };
    }
    return {
      icon: FaBalanceScale,
      label: 'Neutral',
      color: '#6366f1',
      bgColor: 'rgba(99, 102, 241, 0.15)',
      borderColor: 'rgba(99, 102, 241, 0.3)',
      description: 'Mixed market signals'
    };
  };

  const config = getRegimeConfig();
  const Icon = config.icon;

  return (
    <div
      className="market-regime-card"
      style={{
        background: config.bgColor,
        border: `1px solid ${config.borderColor}`,
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: '12px',
          background: config.bgColor,
          border: `1px solid ${config.borderColor}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Icon size={24} color={config.color} />
        </div>
        <div>
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginBottom: '2px' }}>
            Market Regime
          </div>
          <div style={{ fontSize: '18px', fontWeight: '700', color: config.color }}>
            {config.label}
          </div>
        </div>
      </div>

      {notes && (
        <div style={{
          fontSize: '13px',
          color: 'rgba(255,255,255,0.7)',
          lineHeight: '1.5',
          padding: '10px',
          background: 'rgba(0,0,0,0.2)',
          borderRadius: '8px'
        }}>
          {notes}
        </div>
      )}
    </div>
  );
};

export default MarketRegimeCard;
